import { FeatureAnchorsBanner as ModFeatureAnchorsBanner, IProps } from 'mod/featureV2/FeatureAnchorsBanner';
import styles from './index.module.less';

export function FeatureAnchorsBanner(props: IProps): Globals.JSXRenderType {
    return (
        <ModFeatureAnchorsBanner
            className={styles['anchors-banner']}
            popoverClassName={styles.popover}
            {...props}
        />
    )
}

export default FeatureAnchorsBanner;